import {
	ArrowButtons,
	Breakpoints,
	ContainerGutter,
	Gallery,
	GallerySlide,
	Lentils,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { BenefitsCard } from './benefits-card';
import { useIsLandscape } from '../../../hooks/use-is-landscape';
import { BenefitsCombined } from '../benefits';
import { BenefitsLentilsWrapper } from '../../ui/lentils-wrapper';
import { isMobileBreakpoint } from '../../../helpers/breakpoint-helpers';

const GallerySlideContainer = styled(GallerySlide)`
	padding: 0px;
`;

export const BenefitsCarousel = ({
	benefitsCombined,
	handleClickBenefit,
}: {
	benefitsCombined: BenefitsCombined[];
	handleClickBenefit: (benefit: BenefitsCombined) => void;
}): React.ReactElement => {
	const isMobile = isMobileBreakpoint(Breakpoints.b960);
	const isLandscape = useIsLandscape();
	const slidesAt960 = isLandscape ? 3 : 2;

	return (
		<Gallery
			data-testid="benefits-gallery-slider"
			id="benefits-gallery"
			bottomElements={
				<>
					{!isMobile && (
						<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />
					)}

					<BenefitsLentilsWrapper $count={benefitsCombined.length} $slidesAt960={slidesAt960}>
						<Lentils />
					</BenefitsLentilsWrapper>
				</>
			}
			aria-label="Benefits gallery"
			slidesPerPage={{
				[Breakpoints.default]: 1,
				[Breakpoints.b960]: benefitsCombined.length >= slidesAt960 ? slidesAt960 : benefitsCombined.length,
				[Breakpoints.b1280]: benefitsCombined.length >= 3 ? 3 : benefitsCombined.length,
				[Breakpoints.b2560]: benefitsCombined.length >= 4 ? 4 : benefitsCombined.length,
			}}
			fadingEdges="normal"
			gutter={!isMobile ? ContainerGutter.dynamic0100 : undefined}
		>
			{[
				...benefitsCombined.map((benefit, index) => (
					<GallerySlideContainer key={index} aria-labelledby={`slide${index}-heading`} stretch>
						<BenefitsCard benefit={benefit} handleClickBenefit={handleClickBenefit} />
					</GallerySlideContainer>
				)),
			]}
		</Gallery>
	);
};
